import React, { Component } from 'react';
import { Fragment } from 'react';
import {ImageText, DataRPC, MedicineClass} from '../../rpc-client/DataRPC';
import './DetailPage.css';

class Medicine extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            mieuta: "",
            news: []
        }
    }

    async componentDidMount() {
        new DataRPC().fetchData('GetImageText', {
            page: "medicine"
        }, ImageText).then(gData => { 
            if (gData) {
                this.setState({mieuta: gData.find(x => x.komoku == "mieuta").content});
            }
        });

        // Get Medicine
        new DataRPC().fetchData('GetMedicine', {
            type: 2
        }, MedicineClass).then(gData => { 
            //console.log('News ---');
            
            if (gData) {
               this.setState({
                    news: gData
               });
               //console.log(this.state.news);
            }
        });
    }

    allNews = () => {

        let list = [];
            this.state.news.forEach(xxx => {
            
            list.push(
                <div className="hc-med-card" key={xxx.id}>
                    <div className="hc-med-thumb">
                        <img src={xxx.ava} alt=""/>
                    </div>
                    <div className="hc-med-body">
                        <h4>{xxx.name}</h4>
                        <p>{xxx.description}</p>
                        <a href={"medicine-details/"+xxx.id} className="hc-read-more"> Xem thêm <i className="icofont-simple-right"></i></a>
                    </div>
                </div>
            );
        });
    
        return list;
    };

    render() {
        return( 
            <Fragment>

                <section className="hc-section hc-section--alt" style={{paddingTop: 60}}>
                    <div className="hc-container">
                        <div className="hc-section-head">
                            <span className="hc-eyebrow">Nhà thuốc</span>
                            <h2>Danh sách</h2>
                            <div className="hc-divider"></div>
                            <p>{this.state.mieuta}</p>
                        </div>

                        <div className="hc-med-grid">
                            {this.allNews()}
                        </div>
                    </div>
                </section>
            </Fragment>
        )
    }

}

export default Medicine;